/* RESPONSIBLE TEAM: team-standalone */
import type HandoffToSalesforceInAppMessaging from 'embercom/models/operator/visual-builder/step/handoff-to-salesforce-in-app-messaging';
import StepConfig, { type StepConfigParams } from '../step';

export default class HandoffToSalesforceInAppMessagingConfiguration extends StepConfig {
  declare step: HandoffToSalesforceInAppMessaging;

  constructor(params: Omit<StepConfigParams, 'component'>) {
    super({
      component: 'workflows/graph-editor/node-items/steps/handoff-to-salesforce-in-app-messaging',
      ...params,
    });
  }

  get alignment() {
    return 'left' as const;
  }
}
